export default "__VITE_ASSET__6jbw4094__"